import React from 'react';
import ReactDOM from 'react-dom';
// Bootstrap ships with the app rather than being pulled from ivyis.org. A
// stylesheet fetched from one client's web server is a cross-client dependency:
// every other school's transportation page went down with IVY's site, and its
// access log recorded them. Pinned to 5.0.2, the version that URL served.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

import '@fortawesome/fontawesome-free/css/all.min.css';
import { Provider } from 'react-redux';
import store from './store/store';
import { IdentityProvider } from './identity/IdentityProvider';

// The tenant's own backend, on the host the page was served from. The fallback
// keeps the app self-hosting if the env file is missing: identity must come
// from this school's backend, never from a URL compiled into the bundle.
const BASE_URL = process.env.REACT_APP_BASEURL || '/backend';

ReactDOM.render(
  <IdentityProvider baseUrl={BASE_URL}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </IdentityProvider>,
  document.getElementById('root')
);

// f you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
